var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.6908C10.4108 17.6908 8.30917 15.5892 8.30917 13C8.30917 10.4108 10.4108 8.30917 13 8.30917C15.5892 8.30917 17.6908 10.4108 17.6908 13C17.6908 15.5892 15.5892 17.6908 13 17.6908ZM13 9.93417C11.31 9.93417 9.93417 11.31 9.93417 13C9.93417 14.69 11.31 16.0658 13 16.0658C14.69 16.0658 16.0658 14.69 16.0658 13C16.0658 11.31 14.69 9.93417 13 9.93417Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.7717C8.92668 22.7717 5.08085 20.3883 2.43751 16.25C1.28918 14.4625 1.28918 11.5483 2.43751 9.75C5.09168 5.61167 8.93751 3.22833 13 3.22833C17.0625 3.22833 20.9083 5.61167 23.5517 9.75C24.7 11.5375 24.7 14.4517 23.5517 16.25C20.9083 20.3883 17.0625 22.7717 13 22.7717ZM13 4.85333C9.50085 4.85333 6.15335 6.955 3.81335 10.6275C3.00085 11.895 3.00085 14.105 3.81335 15.3725C6.15335 19.045 9.50085 21.1467 13 21.1467C16.4992 21.1467 19.8467 19.045 22.1867 15.3725C22.9992 14.105 22.9992 11.895 22.1867 10.6275C19.8467 6.955 16.4992 4.85333 13 4.85333Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e09c4a42aab3c07081d0027eecaf5173.svg";
export { ForwardRef as ReactComponent };